import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Come rico sin azucar ni harinas',
    img: 'https://cdn.magicpatterns.com/uploads/wJ8NywJMw3b846B1HNSkhD/bono_1_sin_fondo.png'
  }, {
    num: 2,
    title: 'Sistema simple para bajar de peso',
    img: 'https://cdn.magicpatterns.com/uploads/6BLRR4HXnHTJYhr6D38LMV/bono_2_sin_fondo.png'
  }, {
    num: 3,
    title: 'Guia rapida que comer y que evitar',
    img: 'https://cdn.magicpatterns.com/uploads/dDeaUMYpcYnP6voiCxECDL/bono_3_sin_fondo.png'
  }, {
    num: 4,
    title: 'Recetas express listas en 15 minutos o menos',
    img: 'https://cdn.magicpatterns.com/uploads/rnJSCrM6nrpYxEWNcCGk31/bono_4_sin_fondo.png'
  }, {
    num: 5,
    title: 'Lista de compras inteligente sin caer en errores',
    img: 'https://cdn.magicpatterns.com/uploads/qVepPWSKXdb3tWQ8wX6DR6/bono_5_sin_fondo.png'
  }, {
    num: 6,
    title: 'Guia para comer afuera sin arruinar tu progreso',
    img: 'https://cdn.magicpatterns.com/uploads/fpTqP6pyPA5nev1tyddKjQ/bono_6_libro_con_fondo-removebg-preview.png'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 uppercase" data-id="element-26">
            🎁 Y ADEMÁS RECIBÍS 6 BONOS EXCLUSIVOS
          </h2>
          <p className="text-2xl font-bold text-red-600" data-id="element-27">
            Solo si accedés hoy 👇
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-xl border-2 border-yellow-400 overflow-hidden relative flex flex-col cursor-pointer" onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-29">
              <div className="absolute top-0 right-0 bg-red-600 text-white font-black py-1 px-4 rounded-bl-lg z-10 shadow-md text-sm" data-id="element-30">
                GRATIS POR HOY
              </div>

              <div className="bg-gradient-to-b from-yellow-100 to-white pt-8 pb-4 px-4 flex-grow flex flex-col items-center justify-center min-h-[280px]" data-id="element-31">
                <img src={bonus.img} alt={`Bono ${bonus.num}`} className="w-full max-w-[240px] object-contain" width="240" height="240" loading="lazy" decoding="async" data-id="element-32" />
              </div>

              <div className="bg-gray-900 text-white p-5 text-center border-t-4 border-yellow-400" data-id="element-33">
                <div className="text-yellow-400 font-black text-base mb-1" data-id="element-34">
                  BONO {bonus.num}
                </div>
                <h3 className="text-lg font-bold leading-tight" data-id="element-35">
                  {bonus.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-36">
          <CtaButton text="👉 QUIERO EL PACK CON TODOS LOS BONOS" data-id="element-37" />
        </div>
      </div>
    </section>;
}